(function ($) {

	$.ZagParallax = function (element, options) {

		options = $.extend({}, $.ZagParallax.defaultOptions, options);

		var Component = element;

		if (Component.children(".zag-parallax-bg").length) {

			Component.addClass("zag-parallax");
			ZagParallaxSet(Component, options.divisor);

			$(window).on("resize scroll", function () {
				ZagParallaxSet(Component, options.divisor);
			});
		}
	};

	function ZagParallaxSet(Component, divisor) {

		var bg = Component.children(".zag-parallax-bg");

		// parallax coverage is different for components that appear above vs. below the fold
		// if bottom of component is above the fold...
		var bgScale = Component.offset().top + Component.outerHeight() < $(window).height() ? Component.offset().top : $(window).height() - Component.outerHeight();
		var bgHeight = Component.outerHeight() + bgScale / divisor
		var bgTop = ($(window).scrollTop() - Component.offset().top) / divisor;

		bg.height(bgHeight);
		bg.css({ marginTop: bgTop });

	}

	$.fn.ZagParallax = (function (options) {
		return this.each(function () {
			(new $.ZagParallax($(this), options));
		});
	});

	$.ZagParallax.defaultOptions = { divisor: 1 };

})(jQuery);